import { PROMOTIONS } from '../../constant'
import LinkArrow from 'src/pages/dashboard/icons/link-arrow'
import PercentageStar from 'src/pages/dashboard/icons/percentage-star'

export default {
  components: {
    LinkArrow,
    PercentageStar,
  },
  setup() {
    return {
      PROMOTIONS,
      LinkArrow,
      PercentageStar,
    }
  }
}
